<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-4 text-center text-lg-start alignFix posRel">
          <div class="assistant">
            <div class="row assHead g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
              <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
              </div>
            </div>
            <div class="row assContent g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
              <div class="col-10 txt"> Ti trovi a pochi click dalla meta! Il numero di telefono è molto
                importante, ci consentirà di contattarti in caso di necessità ed eviterà attese ulteriori per il tuo rimborso 👌🏻.</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 bgWight formStyle posRel">
          <div class="headForm">
            <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.webp">
          </div>
          <div class="p-4 p-md-4 ">
            <div class="form-check form-switch mb-3">
              <label class="form-check-label" for="flexSwitchCheckDefault">Il passeggero è un minore che viaggiava NON ACCOMPAGNATO dal genitore </label>
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"  v-model="minorenonaccompagnato">
            </div>
            <div class="row g-2">
              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st4_nome_label') }} *</div>
                <input type="text" class="form-control" id="nome" v-bind:placeholder="$t('message.st4_nome')" v-model="nome" v-bind:class="[v$.nome.required.$invalid && showerrors ? 'form-error' : '']">
                <label for="compagnia">Inserisci il tuo nome</label>
                <div class="error" v-if="(v$.nome.required.$invalid ) && showerrors">{{ $t("message.st3_nome_required") }}</div>
              </div>

              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st4_cognome_label') }} *</div>
                <input type="text" class="form-control" id="cognome" v-bind:placeholder="$t('message.st4_cognome')"
                       v-bind:class="[v$.cognome.required.$invalid && showerrors ? 'form-error' : '']" v-model="cognome">
                <label for="compagnia">Inserisci il tuo cognome</label>
                <div class="error" v-if="(v$.cognome.required.$invalid ) && showerrors">{{ $t("message.st3_cognome_required") }}</div>
              </div>

            </div>
            <div class="row g-2">
              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st4_email_label') }} *</div>
                <input type="email" class="form-control" id="email" v-bind:placeholder="$t('message.st4_email')" v-bind:class="[(v$.email.required.$invalid || v$.email.email.$invalid ) && showerrors ? 'form-error' : '']" v-model="email">
                <label for="email">Inserisci un indirizzo email valido</label>
                <div class="error" v-if="(v$.email.required.$invalid ) && showerrors">{{ $t("message.st3_email_required") }}</div>
                <div class="error" v-if="(v$.email.email.$invalid ) && showerrors">{{ $t("message.st3_email_invalid") }}</div>
              </div>

              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st4_telefono_label') }}</div>
                <input type="text" class="form-control" id="tel"
                       pattern="\+?\d{0,3}[\s\(\-]?([0-9]{2,3})[\s\)\-]?([\s\-]?)([0-9]{3})[\s\-]?([0-9]{2})[\s\-]?([0-9]{2})"
                       v-bind:placeholder="$t('message.st4_telefono')" v-bind:class="[v$.telefono.required.$invalid && showerrors ? 'form-error' : '']"
                       v-model="telefono">
                <label for="compagnia">Inserisci il tuo numero</label>
                <div class="error" v-if="(v$.telefono.required.$invalid ) && showerrors">{{ $t("message.st3_telefono_required") }}</div>

              </div>
            </div>
            <div class="form-floating mb-3 fixLabel ">
              <div class="g-2">{{ $t('message.gen_possieuncodicepriorita') }} <a href="#infoCodice" data-bs-toggle="modal" data-target="#infoCodice"><span class="codiceFix">?</span></a></div>
              <input type="text" class="form-control " id="codice" v-bind:placeholder="$t('message.gen_possieuncodicepriorita_placeholder')" v-model="codicepartner" :readonly="partnercodereadonly">
              <label for="volo">Inserisci il codice</label>
              <div class="error" v-if="(codicepartnernonvalido ) && showerrors">{{ $t("message.st3_codicepartner_required") }}</div>
            </div>
            <div class="row g-3 ">
              <div class="col-md-4 order-md-3">
                <span><img class="fixIndietro pointerBtn" src="https://www.rimborsoalvolo.it/cresources/outform/images/indietro.png" @click="precedente()"></span>
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">{{ $t("message.gen_btn_avanti") }} ></button>
              </div>
              <div class="col-md-4 order-md-1">
                <p class="txtFooForm"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/trustpilot-2.svg">Trustpilot 4,9/5 Eccezionale</p>
              </div>
              <div class="col-md-4 order-md-2">
                <p class="txtFooForm"><img class="cuffieAssistenza" src="https://www.rimborsoalvolo.it/cresources/outform/images/cuffieAssistenza.png" alt="">Assistenza telefonica.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
    <popup-codice-priorita></popup-codice-priorita>
  <popup-minore-non-accompagnato></popup-minore-non-accompagnato>
</template>

<script>
import {useStore} from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import MessaggioChiusoOK from "@/components/MessaggioChiusoOK";
import {verificaCodicePartner, verificaTicketEsistente} from "@/lib/verifiche";
import moment from "moment";
import {computed} from "vue";
import {verificaStep} from "@/lib/verificaStep";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import PopupCodicePriorita from "@/components/PopupCodicePriorita";
import PopupMinoreNonAccompagnato from "@/components/PopupMinoreNonAccompagnato.vue";

export default {
  name: "TerzoStep",
  setup() {
    const store = useStore();
    const ticketchiusiokassociati = computed(() => store.state.compilazione.ticketchiusokassociati);
    const partnercodereadonly = computed(() => store.state.compilazione.partner_code_readonly);
    const numerovolo = computed(() => store.state.volo.numerovolo);
    const datavolo = computed(() => store.state.volo.datavolo);
    const s_nome = computed(() => store.state.richiedente.nome);
    const s_cognome = computed(() => store.state.richiedente.cognome);
    const s_email = computed(() => store.state.richiedente.email);
    const s_telefono = computed(() => store.state.richiedente.telefono);
    const s_partnercode = computed(() => store.state.compilazione.partner_code);
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_step3_inviato = computed( ()=>store.state.gtmstate.step3inviato);
    const s_minorenonaccompagnato = computed(()=>store.state.richiedente.minorenonaccompagnato);
    return {
      ticketchiusiokassociati,
      partnercodereadonly,
      numerovolo,
      datavolo,
      s_nome,
      s_cognome,
      s_email,
      s_telefono,
      s_partnercode,
      s_completati,
      s_step3_inviato,
      s_minorenonaccompagnato,
      v$: useVuelidate(),
      setDataVolo : function(datavolo){
        store.dispatch('volo/commitDataVolo',datavolo);
      },
      setPartnerCodeReadOnly:(value)=>{
        store.dispatch('compilazione/commitSetPartnerCodeReadOnly',value)
      },
      setNome: (value)=>{
        store.dispatch('richiedente/commitNome',value);
      } ,
      setCognome: (value)=>{
        store.dispatch('richiedente/commitCognome',value);
      },
      setEmail: (value)=>{
        store.dispatch('richiedente/commitEmail',value);
      },
      setTelefono: (value)=>{
        store.dispatch('richiedente/commitTelefono',value);
      },
      setPartnerCode: (value)=>{
        store.dispatch('compilazione/commitSetPartnerCode',value);
      },
      getVoliChiusiOK: ()=>{
        return store.getters['compilazione/getTicketChiusiOkAssociati'];
      },
      setPartner: (partner)=>{
        store.dispatch('compilazione/commitSetPartner',partner);
      },
      setStepCompletato: function(){
        store.dispatch('compilazione/commitSetStepCompletato',3);
      },
      setStep3Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio3',true);
      },
      setMinoreNonAccompagnato: function(minorenonaccompagnato){
        store.dispatch('richiedente/commitMinoreNonAccompagnato',minorenonaccompagnato);
      }
    }
  },
  components:{
    PopupMinoreNonAccompagnato,
    MessaggioChiusoOK,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
    FakeChat,
    PopupCodicePriorita
  },
  data(){
    return {
      nome: this.s_nome,
      cognome: this.s_cognome,
      email: this.s_email,
      telefono: this.s_telefono,
      codicepartner : this.s_partnercode,
      showerrors : false,
      codicepartnernonvalido:false,
      volichiusiok:this.ticketchiusiokassociati,
      minorenonaccompagnato:false,
      tempModal: null
    }
  },
  validations:{
    nome: {
      required
    },
    cognome:{
      required
    },
    email:{
      required,
      email
    },
    telefono:{
      required
    },
    codicepartner: {

    }
  },
  watch:{
    minorenonaccompagnato:function(value){
      if(value) {
        this.tempModal = new bootstrap.Modal(document.getElementById("infoMinoreNonAccompagnato"));
        this.tempModal.show();
      }
    }
  },
  mounted() {
    let step = verificaStep([...this.s_completati]);
    if(step.step <= 2) { this.$router.push(step.url); }
    else if(step.step > 4) {this.$router.push({name:'step5'});}
    window.scrollTo(0,0);
    if(!this.s_step3_inviato) {
      this.setStep3Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 3,
          }
      );

      if(typeof fbq !== 'undefined') {
        fbq('track','PageView');
        fbq('trackCustom','Step3');
      }

    }

  },
  methods:{
    salvaDati(){
      this.setNome(this.nome);
      this.setCognome(this.cognome);
      this.setEmail(this.email);
      this.setTelefono(this.telefono);
      this.setMinoreNonAccompagnato(this.minorenonaccompagnato);
      if(this.codicepartner !== null && this.codicepartner !== '') {
        this.setPartnerCode(this.codicepartner);
      }
    },
    prossimoStep(codicepartner){
      this.setPartner(codicepartner);
      this.salvaDati();
      this.setStepCompletato();
      this.$router.push({name:'step4'});
    },
    precedente(){
      this.$router.push({name:'step2'});
    },
    ticketEsistente(){
      this.$router.push({name:'ticketesistente'})
    },
    async submit(){
      const valid = await this.v$.$validate();
      if(!valid){
        this.showerrors = true;
        return;
      }
      let me = this;
      verificaTicketEsistente(this.numerovolo,moment(this.datavolo).format("DD/MM/YYYY"),this.email).then((presente)=>{
        if(presente === "OK") {
          if(!me.partnercodereadonly) {
            verificaCodicePartner(this.codicepartner).then((result) => {
              switch (result) {
                case "NOTFOUND":
                  me.codicepartnernonvalido = true;
                  me.showerrors = true;
                  break;
                case "ABORT":
                  me.codicepartnernonvalido = false;
                  me.prossimoStep(result);
                  break;
                default:
                  me.prossimoStep(result);
              }

            }).catch((err) => {
              console.log(err);
              //non deve essere bloccante
              me.salvaDati();
              me.$router.push({name: 'step4'})
            })
          }else{
            me.prossimoStep(me.codicepartner);
          }
        }else{
          me.salvaDati();
          me.ticketEsistente();
        }
      }).catch((err)=>{
        console.log(err);
      })


    },
  }
}
</script>

<style scoped>
.pointerBtn {
  cursor: pointer;
}
</style>
